import { DeleteOutlined } from "@ant-design/icons";
import { Button, Card, Space, Typography } from "antd";
import PropTypes from "prop-types";

const { Text } = Typography;

/**
 *
 * Component renders a list of editable templates
 */
const BasicRender = ({ datasetTemplate, onRemove, isEditable }) => {
  const cardActions = [];
  cardActions.push(
    <Button
      key="delete"
      name="Delete"
      type="primary"
      icon={<DeleteOutlined />}
      onClick={() => {
        onRemove(datasetTemplate.layout_index);
      }}
      disabled={!isEditable}
    />
  );

  return (
    <Card size="small" title={datasetTemplate.name} extra={cardActions}>
      <Space orientation="vertical" size="middle">
        <Text>{datasetTemplate.description}</Text>
      </Space>
    </Card>
  );
};

BasicRender.propTypes = {
  datasetTemplate: PropTypes.object.isRequired,
  onRemove: PropTypes.func.isRequired,
  isEditable: PropTypes.bool,
};

export default BasicRender;
